/* Progressive reading navigation. Content and links remain available without JS. */
(() => {
  function changeHeading(heading, tag) {
    const replacement = document.createElement(tag);
    [...heading.attributes].forEach(attr => replacement.setAttribute(attr.name, attr.value));
    replacement.append(...heading.childNodes);
    heading.replaceWith(replacement);
  }
  function prepareReadingPages(scope = document) {
    scope.querySelectorAll('.shopify-policy__body h1').forEach(heading => changeHeading(heading, 'h2'));
    scope.querySelectorAll('.article-template__content').forEach(content => {
      if (!content.querySelector('h2') && content.querySelector('h3')) {
        content.querySelectorAll('h3').forEach(heading => changeHeading(heading, 'h2'));
        content.querySelectorAll('h4').forEach(heading => changeHeading(heading, 'h3'));
      }
    });
    scope.querySelectorAll('.nv-content-page--nutrition table').forEach(table => {
      table.querySelectorAll('tr:first-child td').forEach(cell => {
        const heading = document.createElement('th');
        [...cell.attributes].forEach(attr => heading.setAttribute(attr.name, attr.value));
        heading.setAttribute('scope', 'col');
        heading.append(...cell.childNodes);
        cell.replaceWith(heading);
      });
    });
    scope.querySelectorAll('.nv-content-page__content,.article-template__content,.shopify-policy__body').forEach((content, index) => {
      if (content.dataset.nvReadingReady) return;
      content.dataset.nvReadingReady = 'true';
      // Keep interactive app content, e.g. the Cookiebot declaration, intact.
      if (content.querySelector('#CookieDeclaration,script[src*="cookiebot"]')) return;
      content.querySelectorAll('p').forEach(paragraph => {
        if (!paragraph.textContent.replace(/\u00a0/g, ' ').trim() && !paragraph.querySelector('img,svg,iframe,video,audio,script,input,button,select,textarea')) paragraph.remove();
      });
      const title = document.querySelector('#MainContent h1')?.textContent.trim();
      const firstHeading = content.querySelector('h2');
      if (firstHeading && firstHeading.textContent.trim() === title) firstHeading.hidden = true;
      let headings = [...content.querySelectorAll('h2')].filter(heading => !heading.hidden && heading.textContent.trim());
      if (headings.length < 4) headings = [...content.querySelectorAll('h2,h3')].filter(heading => !heading.hidden && heading.textContent.trim());
      if (headings.length < 4 || content.textContent.length < 1800) return;
      const toc = document.createElement('details');
      toc.className = 'nv-reading-toc';
      const summary = document.createElement('summary');
      summary.textContent = 'Auf dieser Seite';
      const nativeHeading = headings.find(heading => heading.textContent.trim().toLowerCase() === 'inhaltsverzeichnis');
      const nativeList = nativeHeading?.nextElementSibling;
      if (nativeList && ['OL', 'UL'].includes(nativeList.tagName)) {
        const normalize = text => text.toLowerCase().replace(/^\s*\d+[.)]?\s*/, '').replace(/\s+/g, ' ').trim();
        headings.forEach((heading, headingIndex) => {
          if (!heading.id) heading.id = `nv-recht-${index + 1}-${headingIndex + 1}`;
        });
        nativeList.querySelectorAll('li').forEach(item => {
          if (item.querySelector('a')) return;
          const target = headings.find(heading => normalize(heading.textContent) === normalize(item.textContent));
          if (!target) return;
          const link = document.createElement('a');
          link.href = `#${encodeURIComponent(target.id)}`;
          link.append(...item.childNodes);
          item.append(link);
        });
        summary.textContent = nativeHeading.textContent.trim();
        nativeHeading.replaceWith(toc);
        toc.append(summary, nativeList);
        return;
      }
      const list = document.createElement('ul');
      headings.forEach((heading, headingIndex) => {
        if (!heading.id) {
          const base = `nv-abschnitt-${index + 1}-${headingIndex + 1}`;
          let id = base;
          let suffix = 1;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      toc.append(summary, list);
      content.before(toc);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepareReadingPages());
  else prepareReadingPages();
  document.addEventListener('shopify:section:load', event => prepareReadingPages(event.target));
})();
